import React from "react"

const Switch2 = ({ isChecked, isReadOnly, id }) => {
  return (
    <div className="square-switch">
      <input
        type="checkbox"
        id={id}
        className="switch"
        checked={isChecked}
        readOnly={isReadOnly}
      />
      <label
        htmlFor={id}
        data-on-label="On"
        data-off-label="Off"
        style={{
          cursor: isReadOnly ? "unset" : "pointer",
        }}
      />
    </div>
  )
}

export default Switch2
